/**
 * Een sessie (het token) leeft 24 uur (auth Jwt:AccessTokenHours). Bij het
 * openen van de app wordt hij vernieuwd, tot het plafond van 30 dagen
 * (Jwt:MaxSessionDays). Blijft de app langer dan die 24 uur openstaan, zoals
 * een tabblad op de iPad, dan is de sessie verlopen en logt de gebruiker
 * opnieuw in (eigenaar 21-10-2026: "we moeten hem toch uitloggen"). Bewust
 * niet stilletjes vernieuwen terwijl het tabblad openstaat.
 */

/** Zo vaak kijkt de app, naast elke keer dat het tabblad weer in beeld komt. */
export const KIJK_ELKE_MS = 60 * 1000;

/**
 * Wanneer verloopt dit token, in milliseconden sinds 1970? Uit de claim `exp`
 * (in seconden). Null als er geen token is of het niet te lezen is.
 */
export function verlooptOp(token: string | null | undefined): number | null {
  const deel = token?.split('.')[1];
  if (!deel) {
    return null;
  }
  try {
    const base64 = deel.replace(/-/g, '+').replace(/_/g, '/');
    const opgevuld = base64 + '='.repeat((4 - base64.length % 4) % 4);
    const exp = JSON.parse(atob(opgevuld))?.exp;
    return typeof exp === 'number' ? exp * 1000 : null;
  } catch {
    return null;
  }
}

/**
 * Is dit token verlopen? Zonder (leesbaar) token niet: dat oordeel laat de app
 * dan aan de server over, die met 401 antwoordt.
 */
export function isVerlopen(token: string | null | undefined, nu: number = Date.now()): boolean {
  const op = verlooptOp(token);
  return op !== null && op <= nu;
}
